import React from 'react';

import PropTypes from '../../propTypes';
import * as Fields from './Fields';
import * as m from '../../messages';
import { TranslatedMessage } from 'common/components/Intl';

const NameFieldGroup = ({ showHeading = true, disabled = false }) => (
  <div className="NameFieldGroup">
    <div className="AddressForm__group">
      {showHeading && (
        <div>
          <div className="subhead navy">
            <TranslatedMessage id={m.NAME_TITLE} />
          </div>
          <p className="text flat-blue">
            <TranslatedMessage id={m.NAME_DESCRIPTION} />
          </p>
        </div>
      )}

      <div className="row NameFieldGroup__fields">
        <div className="col-xs-12 col-md-6">
          <Fields.FirstName disabled={disabled} />
        </div>
        <div className="col-xs-12 col-md-6">
          <Fields.LastName disabled={disabled} />
        </div>
      </div>
    </div>
  </div>
);

NameFieldGroup.propTypes = {
  showHeading: PropTypes.bool,
};

export default NameFieldGroup;



// WEBPACK FOOTER //
// ./app/javascript/apps/age_verification/components/forms/NameFieldGroup.js